import {
  Divider,
  DownloadIcon,
  DragDrop,
  GKButton,
  Grid2,
  Typography,
} from "components";
import { useMutation } from "hooks/useQueries";
import { useState } from "react";
import { Controller, useForm } from "react-hook-form";
import axiosInstance from "utils/axiosInstance";
import { paletteLightTheme } from "utils/ColorTheme";
import { exportArrayBufferToExcel } from "utils/exportCsv";

const ComplainResolution = () => {
  const [uploadError, setUploadError] = useState<any>();
  const [downloadType, setDownloadType] = useState(null);

  const { mutate: downloadSampleFile } = useMutation({
    mutationKey: ["DOWNLOAD_COMPLAIN_RESOLUTION_SAMPLE_FILE"],
    mutationFn: (data) =>
      axiosInstance.post("/download-sheet/", data, {
        responseType: "arraybuffer",
      }),
    onSuccess: (response) => {
      exportArrayBufferToExcel(response.data, downloadType);
      setDownloadType(null);
    },
  });

  const { mutate: uploadComplains, isLoading } = useMutation({
    mutationKey: ["UPLOAD_COMPLAIN_RESOLUTIONS"],
    mutationFn: (data) => axiosInstance.post("/upload-complaints/", data),
  });

  const form = useForm({
    defaultValues: {
      monthly: [],
      monthWise: [],
      annual: [],
    },
  });

  const DownloadBtn = ({ type }: { type: string }) => {
    return (
      <GKButton
        sx={{
          py: 0,
          color: paletteLightTheme.palette.grey[500],
          display: "flex",
          alignItems: "center",
          "&:hover": { background: "transparent" },
        }}
        target="_blank"
        startIcon={<DownloadIcon width={14} height={14} />}
        onClick={() => {
          setDownloadType(type);
          downloadSampleFile({ type });
        }}
      >
        Download Sample File
      </GKButton>
    );
  };

  return (
    <form
      onSubmit={form.handleSubmit((values: any) => {
        const formData = new FormData();

        if (values.monthly.length === 1) {
          formData.append("monthly", values.monthly[0]);
        }
        if (values.monthWise.length === 1) {
          formData.append("monthWise", values.monthWise[0]);
        }
        if (values.annual.length === 1) {
          formData.append("annual", values.annual[0]);
        }

        uploadComplains(formData);
      })}
    >
      <Grid2 container spacing={2}>
        <Grid2 size={3}>
          <Typography
            fontSize={16}
            fontWeight={500}
            color={"var(--neutral-500)"}
          >
            Current Month
          </Typography>
        </Grid2>
        <Grid2 container size={9} spacing={2}>
          <Grid2 size={12}>
            <Controller
              name={"monthWise"}
              control={form.control}
              render={({ field, fieldState: { error } }) => (
                <DragDrop
                  {...field}
                  uploadError={uploadError}
                  setUploadError={setUploadError}
                  onChange={(e) => field.onChange(e)}
                  supportName="CSV & XLSX"
                  acceptType={".csv,.xlsx"}
                  error={!!error}
                />
              )}
            />
            <DownloadBtn type="month-wise" />
          </Grid2>
        </Grid2>
        <Grid2 size={12}>
          <Divider />
        </Grid2>
        <Grid2 size={3}>
          <Typography
            fontSize={16}
            fontWeight={500}
            color={"var(--neutral-500)"}
          >
            Monthly
          </Typography>
        </Grid2>
        <Grid2 container size={9} spacing={2}>
          <Grid2 size={12}>
            <Controller
              name={"monthly"}
              control={form.control}
              render={({ field, fieldState: { error } }) => (
                <DragDrop
                  {...field}
                  uploadError={uploadError}
                  setUploadError={setUploadError}
                  onChange={(e) => field.onChange(e)}
                  supportName="CSV & XLSX"
                  acceptType={".csv,.xlsx"}
                  error={!!error}
                />
              )}
            />
            <DownloadBtn type="monthly" />
          </Grid2>
        </Grid2>
        <Grid2 size={12}>
          <Divider />
        </Grid2>
        <Grid2 size={3}>
          <Typography
            fontSize={16}
            fontWeight={500}
            color={"var(--neutral-500)"}
          >
            Annually
          </Typography>
        </Grid2>
        <Grid2 container size={9} spacing={2}>
          <Grid2 size={12}>
            <Controller
              name={"annual"}
              control={form.control}
              render={({ field, fieldState: { error } }) => (
                <DragDrop
                  {...field}
                  uploadError={uploadError}
                  setUploadError={setUploadError}
                  onChange={(e) => field.onChange(e)}
                  supportName="CSV & XLSX"
                  acceptType={".csv,.xlsx"}
                  error={!!error}
                />
              )}
            />
            <DownloadBtn type="yearly" />
          </Grid2>
        </Grid2>

        <Grid2 size={12} mt={2} display={"flex"} justifyContent={"flex-end"}>
          <GKButton type="submit" variant="contained" loading={isLoading}>
            Save
          </GKButton>
        </Grid2>
      </Grid2>
    </form>
  );
};

export default ComplainResolution;
